import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

// import { getNotices } from '../../api/kquake'
import { fetchNotices, selectAllNotices } from '../../../store/noticesSlice'


const NUMBER_OF_NOTICES_PER_PAGE = 15


export const Notices = () => {

  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1)
  const [filterType, setFilterType] = useState('filter_by_title')
  const routerHistory = useHistory()

  const dispatch = useDispatch()
  const fetchStatus = useSelector(state => state.notices.fetchStatus)
  useEffect(() => {
    if (fetchStatus === 'idle') {
      dispatch(fetchNotices())
    }
  }, [fetchStatus, dispatch])

  useEffect(() => {
    // Init select element
    // https://materializecss.com/select.html
    const elems = document.querySelectorAll('select')
    window.M.FormSelect.init(elems)
  }, [])

  const notices = useSelector(selectAllNotices)
  const numOfPages = Math.ceil(notices.length / NUMBER_OF_NOTICES_PER_PAGE)

  const pageNumberButtons = (numOfPages > 1 ? [...Array(numOfPages).keys()] : [0]).map((key) => {
    let pageNumber = key + 1
    let className = pageNumber === currentPage ? 'pagenumber active' : 'pagenumber waves-effect'
    return (
      <li key={pageNumber} className={className} onClick={() => setCurrentPage(pageNumber)}><a>{pageNumber}</a></li>
    )
  })
  const pageMoveButtons = (
    <ul className="pagination">
      <li className="pagearrow waves-effect hide-on-med-and-down"><a onClick={() => setCurrentPage(1)}><i className="ion ion-ios-arrow-back"></i><i className="ion ion-ios-arrow-back"></i></a></li>
      <li className="pagearrow waves-effect"><a onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage)}><i className="ion ion-ios-arrow-back"></i></a></li>
      {pageNumberButtons}
      <li className="pagearrow waves-effect"><a onClick={() => setCurrentPage(currentPage < numOfPages ? currentPage + 1 : currentPage)}><i className="ion ion-ios-arrow-forward"></i></a></li>
      <li className="pagearrow waves-effect hide-on-med-and-down"><a onClick={() => setCurrentPage(numOfPages)}><i className="ion ion-ios-arrow-forward"></i><i className="ion ion-ios-arrow-forward"></i></a></li>
    </ul>
  )

  const firstStationIndex = (currentPage - 1) * NUMBER_OF_NOTICES_PER_PAGE
  const noticeElements = notices.slice(firstStationIndex, firstStationIndex + NUMBER_OF_NOTICES_PER_PAGE).map((notice, index) => {
    return (
      <tr key={index} onClick={() => routerHistory.push(`/intro/notices/${notice.id}`)}>
        <td className="hide-on-med-and-down">{firstStationIndex + index + 1}</td>
        <td className="table_title truncate">{notice.important && <span>[{t('w.important')}]</span>} {notice.title} </td>
        <td className="hide-on-med-and-down">{notice.author}</td>
        <td>{notice.lastModified && notice.lastModified.slice(0, 10)}</td>
        <td className="truncate hide-on-med-and-down">
          {/* <a><img src="/images/btn_icon_file.png" className="mr5" alt="file-download"/></a>
          <a><img src="/images/btn_icon_file.png" className="mr5" alt="file-download"/></a>
          <a><img src="/images/btn_icon_file.png" className="mr5" alt="file-download"/></a>
          <a><img src="/images/btn_icon_file.png" className="mr5" alt="file-download"/></a> */}
        </td>
      </tr>
    )
  })

  return (
    <div className="container">
      <p></p>
      <div className="sub-container">
          <div className="board_info">
            <div className="row">
              <div className="input_insearch_container input-field col l3 m6 s12 right">
                <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                  <option value="filter_by_title">{t('w.title')}</option>
                  <option value="filter_by_author">{t('w.writer')}</option>
                  <option value="filter_by_content">{t('w.mainText')}</option>
                </select>
                <input id="icon_prefix" type="text" className="validate" />
                <label className="input_insearch_icon" htmlFor="icon_prefix">
                  <i className="ion ion-ios-search">　</i>
                </label>
              </div>
            </div>
          </div>
          <div className="notice-list-table">
            <table className="highlight">
              <thead>
                <tr>
                  <th style={{width: "60px"}} className="hide-on-med-and-down">NO.</th>
                  <th style={{width: "auto"}} className="table_title">{t('w.title')}</th>
                  <th style={{width: "120px"}} className="hide-on-med-and-down">{t('w.writer')}</th>
                  <th style={{width: "150px"}}>{t('w.created')}</th>
                  <th style={{width: "100px"}} className="hide-on-med-and-down">{t('w.attachment')}</th>
                </tr>
              </thead>
              <tbody>
                {noticeElements}
              </tbody>
            </table>
            <div className="pagenum">
              {pageMoveButtons}
            </div>
            {/* <div className="row">
              <button className="right col l2 s12 waves-effect waves-light btn-large" onclick="location.href ='./sub_notice_write.html'">글쓰기</button>
            </div> */}

        </div>

      </div>
    </div>
  );
}